module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-1.e24a25fe.png";